<div class="asset-inspection-status-chip-component {{toClass()}}">
  {{status}}
</div>